import { useState } from 'react';
import PropTypes from 'prop-types';
import { Edit2, Save, X } from 'lucide-react';
import { Card, CardContent, FormTextArea, PrimaryButton, SecondaryButton } from '@shared/forms/FormStyles';

const PersonalStatementSection = ({ personalStatement, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedStatement, setEditedStatement] = useState(personalStatement || '');

  const handleSave = () => {
    onSave(editedStatement);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedStatement(personalStatement || ''); // Reset to original
    setIsEditing(false);
  };

  // Don't render the card at all if there's no statement initially and not editing
  if (!personalStatement && !isEditing) {
    return null;
  }

  return (
    <Card>
      <div className="border-b border-huntd-secondary/10 bg-white px-6 py-4 flex justify-between items-center">
        <h3 className="text-xl font-bold text-huntd-primary">Personal Statement</h3>
        {!isEditing && personalStatement && ( // Show edit only if not editing and statement exists
          <SecondaryButton onClick={() => setIsEditing(true)} size="sm">
            <Edit2 size={16} className="mr-1" /> Edit
          </SecondaryButton>
        )}
      </div>
      <CardContent>
        {isEditing ? (
          <div className="space-y-3">
            <FormTextArea
              label="Edit Personal Statement"
              hideLabel={true} // Visually hide label, but keep for accessibility
              value={editedStatement}
              onChange={(e) => setEditedStatement(e.target.value)}
              rows={5}
              placeholder="Enter your personal statement"
            />
            <div className="flex justify-end gap-2">
              <SecondaryButton onClick={handleCancel} size="sm">
                <X size={16} className="mr-1" /> Cancel
              </SecondaryButton>
              <PrimaryButton onClick={handleSave} size="sm">
                <Save size={16} className="mr-1" /> Save Statement
              </PrimaryButton>
            </div>
          </div>
        ) : (
          <p className="text-base text-huntd-secondary">{personalStatement || 'No personal statement provided.'}</p>
        )}
      </CardContent>
    </Card>
  );
};

PersonalStatementSection.propTypes = {
  personalStatement: PropTypes.string,
  onSave: PropTypes.func.isRequired // Callback to save the updated statement
};

export default PersonalStatementSection;